import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { LeftButton, RightButton } from 'components';
import { scrollToAnchor } from 'utils';
import { useWindowSize } from 'hooks';

function PageControls({
  products,
  paginatedProducts,
  productsPerPage,
  currentPage,
  setCurrentPage
}) {
  const [pageNumbers, setPageNumbers] = useState([]);
  const { windowWidth } = useWindowSize();

  useEffect(() => {
    const _pageNumbers = [];

    for (let i = 1; i <= Math.ceil(products.length / productsPerPage); i++) {
      _pageNumbers.push(i);
    }

    setPageNumbers(_pageNumbers);
  }, [paginatedProducts]);

  const scrollToTopOfGrid = () =>
    scrollToAnchor('top-of-product-grid', { offset: -146, duration: 1000 });

  return (
    <Container>
      <LeftButton
        onClick={() => {
          setCurrentPage((_currentPage) => _currentPage - 1);
          scrollToTopOfGrid();
        }}
        disabled={currentPage === pageNumbers[0]}
      />
      {windowWidth < 1200 && pageNumbers.length > 5 ? (
        <PrevNextWhenTooManyPagesOnSmallScreen>
          Prev/Next
          <br />
          Page
        </PrevNextWhenTooManyPagesOnSmallScreen>
      ) : (
        pageNumbers.map((number) => (
          <PageNumber
            key={number}
            id={number}
            onClick={(e) => {
              setCurrentPage(Number(e.target.id));
              scrollToTopOfGrid();
            }}
            highlight={number === currentPage}>
            {number}
          </PageNumber>
        ))
      )}
      <RightButton
        onClick={() => {
          setCurrentPage((_currentPage) => _currentPage + 1);
          scrollToTopOfGrid();
        }}
        disabled={currentPage === pageNumbers.length}
      />
    </Container>
  );
}

const PrevNextWhenTooManyPagesOnSmallScreen = styled.p`
  color: var(--connolly-red);
  font-weight: 700;
  margin: 0 0.5rem;
  text-align: center;
`;

const Container = styled.ul`
  display: flex;
  grid-column: 1/-1;
  justify-content: center;
  list-style: none;
  margin-top: 1rem;

  button,
  li {
    margin: 0 0.313em;
  }

  button {
    background-color: var(--connolly-red);

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }

  @media (width >= 48rem) {
    button:last-of-type {
      margin-right: 0;
    }
  }
`;

const PageNumber = styled.li`
  align-items: center;
  border: 0.063em solid var(--connolly-red);
  border-radius: 0.375em;
  box-sizing: border-box;
  color: var(--connolly-red);
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  height: 2.5em;
  justify-content: center;
  margin-right: 0.3em;
  user-select: none;
  width: 2.5em;

  ${({ highlight }) =>
    highlight &&
    css`
      background-color: var(--connolly-red);
      color: #fff;
    `}
`;

export default PageControls;
